import React, {useEffect} from "react" ;

import { Link } from "react-router-dom" ;

const AppSidebarMenuItem= (props) =>
{
    const activeClassName = props.active ? ' active' : '' ;
    const textColorClassName = props.tagColor === undefined ? '' : ' ' + props.tagColor ;
    const iconClassName = props.iconName === undefined ? 'icon-tag' : props.iconName ;

    useEffect(()=>{
    }, [props.active]);

    const onClick = () =>
    {
        props.onClick ( props.name ) ;
    }

    if ( props.link !== null )
    {
        return (
            <li className={"dt-module-side-nav__item" + activeClassName }>
                <Link onClick={onClick} to={props.link} className="dt-module-side-nav__link">
                    <i className={"icon " + iconClassName + " icon-fw icon-lg" + textColorClassName }/>
                    <span className="dt-module-side-nav__text">{props.title}</span>
                    { props.count !== 0 && <span style={{marginLeft: '40px', color: "red"}}>{props.count}</span>}
                </Link>
            </li>
        ) ;

    }
    else
    {
        return (
            <li className={"dt-module-side-nav__item" + activeClassName }>
                <a href="#" className="dt-module-side-nav__link">
                    <i className={"icon " + iconClassName + " icon-fw icon-lg" + textColorClassName }/>
                    <span className="dt-module-side-nav__text">{props.title}</span> </a>
            </li>
        ) ;

    }
}

export default AppSidebarMenuItem;
